export default __webpack_public_path__ + "static/media/icon_videos.baa935bd.svg";